module.exports = __webpack_public_path__ + "img/xd.9e6b9ba1.png";